import { render, staticRenderFns } from "./button_setting.vue?vue&type=template&id=a9ed43f2&"
import script from "./button_setting.vue?vue&type=script&lang=js&"
export * from "./button_setting.vue?vue&type=script&lang=js&"
import style0 from "./button_setting.vue?vue&type=style&index=0&id=a9ed43f2&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports